/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Comparison_HelpInputs */



/**
* | output |
* | --- |
* | "Each interval is compared with the same interval of another period: same months in the monthly view, same weekdays in the daily view. The reference period gi..." |
*
* @param {Consumption_Comparison_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_help = /** @type {((inputs?: Consumption_Comparison_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Each interval is compared with the same interval of another period: same months in the monthly view, same weekdays in the daily view. The reference period gives each month's average and is shown in the monthly view.")
	return /** @type {LocalizedString} */ ("Chaque intervalle est comparé au même intervalle d'une autre période : mêmes mois en vue mensuelle, mêmes jours de la semaine en vue jour. La période de référence donne la moyenne de chaque mois et s'affiche en vue mensuelle.")
});